import type {
  ActionItemDraftReviewProjectionAdapter,
  TranscriptSegmentReviewLocator,
} from './types.ts';

function transcriptSegmentReviewLocator(segmentId: string): TranscriptSegmentReviewLocator {
  return { adapterId: 'transcriptSegment', segmentId };
}

export const transcriptSegmentReviewProjectionAdapter: ActionItemDraftReviewProjectionAdapter = {
  adapterId: 'transcriptSegment',
  project(draft) {
    const block = draft.evidenceBlock;
    if (
      block.isActionItem !== true
      || block.sourceType !== 'transcriptSegment'
      || block.entityType !== 'transcriptSegment'
      || typeof block.entityId !== 'string'
      || typeof block.transcriptSegmentId !== 'string'
      || block.entityId !== block.transcriptSegmentId
      || typeof block.transcriptSessionId !== 'string'
    ) {
      return null;
    }

    return {
      locator: transcriptSegmentReviewLocator(block.transcriptSegmentId),
      evidenceKey: block.evidenceKey,
    };
  },
};
